import { render } from "./CourseDetailsForm.vue?vue&type=template&id=760d89fa&scoped=true"
import script from "./CourseDetailsForm.vue?vue&type=script&lang=js"
export * from "./CourseDetailsForm.vue?vue&type=script&lang=js"

import "./CourseDetailsForm.vue?vue&type=style&index=0&id=760d89fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760d89fa"]])

export default __exports__